import React, { Component } from 'react'
import { Spin, Layout, PageHeader, Avatar, Input, Icon, Form } from 'antd'

import PrevImg from '_src/components/PrevImg/PrevImg'
import {getUserDetail} from '_src/api/api'

class UserDetail extends Component {
  state = {
    isLoading: true,
  }
  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')

    // 用户详情
    getUserDetail({id})
      .then(res => {
        const { avatar } = res.data
        res.data.avatar = avatar ? res.data.avatar.replace('/132', '/0'): null
        this.setState({
          isLoading: false,
          info: res.data
        })
      })
  }

  render () {
    const {
      info,
      isLoading,
    } = this.state
    return (
      <Layout className="createTravel-page" style={{ padding: 20, paddingTop: 40, backgroundColor: 'white' }}>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='flex-h-a' title='查看用户详情' style={{borderLeft: '5px solid #1890ff', height: 30}} />
        {
          info && (
            <Form onSubmit={this.handleSubmit} className="">
              <PageHeader className='flex-h-a' title='基本信息' style={{height: 30, padding: '50px 50px 25px'}} />
              <Form.Item label="头像" className='flex'>
                <Avatar shape="square" size={64} icon="user" style={{cursor: 'pointer'}} src={info.avatar} onClick={()=>this.PrevImg.show(info.avatar)} />
              </Form.Item>
              <Form.Item label="昵称" className='flex'>
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} value={info.nickname} readOnly />
              </Form.Item>
              <Form.Item label="手机号" className='flex'>
                <Input prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} value={info.mobile} readOnly />  
              </Form.Item>
              <Form.Item label="性别" className='flex'>
                <Input prefix={<Icon type="woman" style={{ color: 'rgba(0,0,0,.25)' }} />} value={info.gender === 1 ? '男' : '女'} readOnly />  
              </Form.Item>
              <Form.Item label="注册时间" className='flex'>
                <Input prefix={<Icon type="clock-circle" style={{ color: 'rgba(0,0,0,.25)' }} />} value={info.createAt} readOnly />  
              </Form.Item>
              {/* <Form.Item label="喜欢的分类" className='flex'>
                <div>
                  {[0, 1, 2, 3].map(item => <Tag >{item}</Tag>)}
                </div>
                后台没有返回，放一点假内容填充
              </Form.Item> */}
            </Form>
          )
        }
      </Layout>
    )
  }
}

export default UserDetail